<ng-container
  *ngIf="{
    isVolunteer: isVolunteer$ | async,
    displaySocialLogin: displaySocialLogin$ | async
  } as obs"
>
  <gb-register-form [dialog]="true" [registerExtras]="registerExtras">
    <div class="header-container" header>
      <mat-toolbar role="toolbar" class="gb-dialog-header">
        <h2 mat-dialog-title [translate]="obs.isVolunteer ? 'VOLUNTEER.REGISTER.HEADER' : 'REGISTER_HEADER'"></h2>
        <button mat-icon-button mat-dialog-close>
          <mat-icon mat-list-icon>close</mat-icon>
        </button>
      </mat-toolbar>

      <p *ngIf="obs.isVolunteer" translate="VOLUNTEER.REGISTER.REGISTER_INFO" class="register-subheader"></p>

      <div class="social-login-container" *ngIf="!obs.isVolunteer && obs.displaySocialLogin">
        <gb-social-login-register [dialog]="true" [redirectHome]="false"></gb-social-login-register>

        <div class="divider-container flex-row flex-justify-space-between flex-align-center flex-fill">
          <mat-divider> </mat-divider>
          <span translate="AUTH.REGISTER.OR"></span>
          <mat-divider> </mat-divider>
        </div>
      </div>
    </div>
  </gb-register-form>
</ng-container>
